import * as React from 'react';
import {FunctionComponent} from 'react';
import {Link} from 'react-router-dom';

export interface LinkButtonProps {
    to: string;
    children: any;
    className?: string;
}

export const LinkButton: FunctionComponent<LinkButtonProps> = ({to, children, className}) => <Link
    className={className ? className : 'btn btn-link'}
    to={to}>
    {children}
</Link>;
